import $ from 'jquery';
window.addEventListener('px-ready',function(){
    $('.px-loadmore .c-event__load-btn a').click(function(){
        var container = $(this).parentsUntil('.px-loadmore').parent();
        var type = "upcoming-events";
        if(container.hasClass('is-past-event')){
            type='past-event';
        }
        //console.log(container);
        console.log(type);
        jQuery.post(
            ajaxurl,
            {
                'action': 'px_loadmore_ajax',
                'type': type,
                'offset': container.find('.c-event').length,
                //'tax': tax,
                //'term': term,
            },
            function(response){
                // OK pour prochain Call
                //console.log(response);
                if(response != '<!--ended-->'){
                    /*$('.ajaxLoad').append(response);
    
                    setTimeout(function(){
                        $('.projectCard').addClass('appeared');
                    },50)
                    setTimeout(function(){
                        $('.ajaxLoad').attr('data-ajax-offset',$('.projectCard').length)
                        pixOnResize();
                    },200);*/
                    container.find('.cards').append(response);
                    //container.find('cards').css('background', '#f00');
                    $(window).trigger('resize').trigger('scroll');
                    /*window.dispatchEvent(new Event('px-new-cards'));
                    setTimeout(function(){
                        $('.is-animated').addClass('readytoanimate');
                    },100)*/
                }else{
                    //$('.ajaxtrigger').remove();
                    container.find('.c-event__load-btn').remove();
                }
                setTimeout(function(){
                    $('[js-loadmore-ajax]').attr('loadmore-inprogress',0);
                    $('.filters select').trigger('change');
                    window.dispatchEvent(new Event('px-new-cards'));
                },200);
                return false;
            }
        );
        return false;
    })
})